
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppButton, AppSelect, AppCard, AppDateTimePicker } from '@/components';
import useItemSettingAdd from '@/modules/item/app/setting/model/add';
import { ROUTE_NAME_ITEM } from '@/modules/item/router';

export default defineComponent({
    name: ROUTE_NAME_ITEM.APP_SETTING.ADD,
    components: { AppFormRow, AppInput, AppButton, AppSelect, AppCard, AppDateTimePicker },
    setup() {
        const { model, v$, timeUnits, create } = useItemSettingAdd();

        return { v$, model, timeUnits, create };
    }
});
